import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from './../../../../constants/endpoints';
import { Value } from '@philips-internal/oswald-ui-core';

export interface GastherapyProps {
  actionType?: string;
  breathingType?: string;
  deviceCode?: string;
  deviceDescription?: string;
  qtOxygenFraction?: number;
  quantity?: number;
  reasonDescription?: string;
  respiratoryModality?: string;
  sequenceId?: number;
  unitOfMeasurement?: string;

}

export interface CurrentRecordRevert {
  currentTime?: string;
  observation?: string;
  sequenceNumber?: number;
}

export interface CreateGenerateGastherapyChangeRequest {
  device?: string;
  dsMessage?: string;
  dtChange?: string;
  ieChange?: string;
  ieJava?: string;
  justification?: string | null;
  nameUser?: string;
  nrSeqReason?: number;
  prescriptionNumber?: number;
  qtGastherapy?: number;
  scheduleSeq?: number;
  seqDeviceModel?: number;
  seqEquipment?: number;
  seqGastherapy?: number;
  seqGastherapyCpoe?: number;
  signatureSeq?: number;
  unitOfMeasurement?: string;
}

export interface CreateGenerateGastherapyChangeResponse {
  dsMessage?: string;
}

export interface ObtainGasCourseResponse {
  message?: string;
}

export enum GastherapyItemStatus {
  INTERRUPTED = 'IN',
  NOT_STARTED = 'N',
  RESTARTED = 'R',
  STARTED = 'I',
  TERMINATE = 'T',
  REVERSE = 'RV',
}

export enum GastherapyStatus {
  INTERRUPTED = 'INTERRUPTED',
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  TERMINATE = 'TERMINATE',
  RESTARTED = 'RESTARTED',
}

export default class GastherapyService{

  public static generateGasTherapyChange(request: CreateGenerateGastherapyChangeRequest): Promise<CreateGenerateGastherapyChangeResponse> {
    const body = Object.assign({}, request) as unknown as Record<string, Value>;
    return HttpService.post(
      Endpoint.EMAR_POST_GENERATE_GASTHERAPY_CHANGE, {}, { body }).then(response => {
      const result = response.body as CreateGenerateGastherapyChangeResponse;
      result.dsMessage = result.dsMessage ? replaceMessage(result.dsMessage) : '';
      const msg = !isNullOrEmpty(result.dsMessage) ? result.dsMessage : null;
      return msg as CreateGenerateGastherapyChangeResponse;
    });
  }
}

function replaceMessage(msg: string): string {
  const lines = msg.split('\n');
  for (const line of lines) {
    if (
      !['ORA-06512', 'line'].includes(line) &&
      !/^\s*$/.test(line)
    ) {
      return line
        .replace(/ORA-\d+:\s*/g, '')
        .replace(/#@#@/, '')
        .trim();
    }
  }
  return msg.trim();
}

function isNullOrEmpty(
  value: string | null | undefined | number | unknown[]): boolean {
  return (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0));
}
